const trackClick = (category, action, label, additional) => {
    let data = {
        event: 'trackClick',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
    };
    data = { ...data,...additional};
    window.dataLayer.push(data);
}

export default { trackClick } 